import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  DoCheck
} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
    selector: 'app-custom-select-option',
    templateUrl: './custom-select-option.component.html',
    styleUrls: ['./custom-select-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomSelectOptionComponent implements AfterContentInit, DoCheck {
  @ViewChild('content', {static: true}) content!: ElementRef;

  @Input() value: any;
  @Input() optionIcon: string;
  @Input() isSelected: boolean = false;
  @Input() isHidden = false;
  @Input() displayLabel: string;
  // Replaces the option content (icon included) with this text when the option is shown as the selected value in the trigger
  @Input() previewLabel: string;
  // A disabled option is shown but cannot be selected
  @Input() disabled = false;

  @Output() click = new EventEmitter();

  label: string;
  sanitizedHtml: SafeHtml;
  private renderedHtml = '';

  constructor(private sanitizer: DomSanitizer,
              private cdRef: ChangeDetectorRef) {}

  ngAfterContentInit() {
    this.syncContent();
  }

  ngDoCheck() {
    if (this.content?.nativeElement) this.syncContent();
  }

  private syncContent() {
    const html = this.content.nativeElement.innerHTML + (this.previewLabel ?? '');
    if (html === this.renderedHtml) return;
    this.renderedHtml = html;
    this.label = this.displayLabel?.trim() || this.content.nativeElement.textContent.trim();
    this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.previewLabel ? this.buildPreviewHtml() : this.content.nativeElement.innerHTML);
  }

  private buildPreviewHtml(): string {
    const preview = document.createElement('span');
    preview.appendChild(document.createTextNode(this.previewLabel));
    return preview.innerHTML;
  }

  setSelected(value: boolean) {
    if (this.isSelected === value) return;
    this.isSelected = value;
    this.cdRef.detectChanges();
  }

  setHidden(value: boolean) {
    if (this.isHidden === value) return;
    this.isHidden = value;
    this.cdRef.detectChanges();
  }
}
